// Layers.js — مودال موحّد + زر إظهار عائم + تتبّع تلقائي لإضافة/حذف الطبقات
import { getlayerByName } from './CustomFunctions.js';
import { map } from './Map.js';
import { HIDDEN_LAYER_NAMES } from './Config.js';

const layers = map.getLayers(); // مجموعة الطبقات على الخريطة

let isLayersOpen = false;

/* =========================
   إعداد أسماء الطبقات المخفية + دالة فحص موحّدة
   ========================= */
const hiddenLayerNames = HIDDEN_LAYER_NAMES;
function isHiddenLayer(layer) {
  // يُستثنى إذا: internal=true أو uiHidden=true أو الاسم ضمن القائمة
  const name = layer.get && layer.get('name');
  return (
    layer?.get?.('internal') === true ||
    layer?.get?.('uiHidden') === true ||
    (name && hiddenLayerNames.includes(name))
  );
}

/* =========================
   حفظ/استعادة حالة الطبقات (Session Persistence)
   ========================= */
const LAYERS_SESSION_KEY = 'geopst_layer_visibility';

function saveLayerVisibility() {
  const visible = [];
  const hidden = [];
  map.getLayers().forEach(layer => {
    const name = layer.get('name');
    if (!name || isHiddenLayer(layer)) return;
    (layer.getVisible() ? visible : hidden).push(name);
  });
  try {
    localStorage.setItem(LAYERS_SESSION_KEY, JSON.stringify({ visible, hidden }));
  } catch { /* quota exceeded — skip silently */ }
}

function restoreLayerVisibility() {
  try {
    const raw = localStorage.getItem(LAYERS_SESSION_KEY);
    if (!raw) return;
    const { visible = [], hidden = [] } = JSON.parse(raw);
    [...visible, ...hidden].forEach(name => {
      const layer = getlayerByName(name);
      if (!layer) return;
      layer.setVisible(visible.includes(name));
    });
  } catch { /* ignore corrupted data */ }
}

// ── استعادة الحالة فور تحميل الموديول (قبل أي تفاعل من المستخدم) ──
restoreLayerVisibility();

/* =========================
   زر "إظهار طبقات الخريطة" العائم
   ========================= */
(function ensureLayersShowChip() {
  if ($('#layersShowChip').length) return;
  const chip = $(`
    <div id="layersShowChip">
      <button type="button" id="layersShowChipBtn">
        <i class="fas fa-layer-group"></i> إظهار طبقات الخريطة
      </button>
    </div>
  `);
  $('body').append(chip);
  $('#layersShowChipBtn').on('click', () => { $('#layersModal').css('display', 'flex'); $('#layersShowChip').hide(); });
})();

/* =========================
   تصغير قوي لمودال الطبقات - الأنماط الآن في components.css
   ========================= */

/* =========================
   زر الطبقات في الشريط الجانبي
   ========================= */
$('#layers').off('click').on('click', function (e) {
  e.preventDefault();
  const button = $(this);
  const section = $('#layersSection');
  if (!isLayersOpen) {
    startLayers(button);
    section.slideDown(200);
  } else {
    stopLayers(button);
    section.slideUp(200);
  }
});

/* =========================
   تشغيل/إيقاف أداة الطبقات
   ========================= */
function startLayers(button) {
  isLayersOpen = true;
  button.addClass('active');
  button.find('span').text('إغلاق الطبقات');
  button.find('i').removeClass('fa-layers').addClass('fa-times');
  showLayersPanel();
}

function stopLayers(button) {
  isLayersOpen = false;
  button.removeClass('active');
  button.find('span').text('الطبقات');
  button.find('i').removeClass('fa-times').addClass('fa-layers');
  hideLayersPanel();
}

function closeLayersCompletely() {
  isLayersOpen = false;
  const btn = $('#layers');
  btn.removeClass('active');
  btn.find('span').text('الطبقات');
  btn.find('i').removeClass('fa-times').addClass('fa-layers');

  $('#layersModal').hide();
  $('#layersShowChip').hide();
}

// Removed old modal code

function showLayersPanel() {
  // ensureLayersModal(); // Removed since we use sidebar now

  // إغلاق أدوات أخرى إن وُجدت (يتم التعامل معه الآن مركزيًا عبر ToolsHub)

  const panelHtml = `
    <div style="text-align:right;direction:rtl;">
      <div class="layers-control-group">
        <div class="section-header">
          <span>الطبقات المتاحة</span>
          <i class="fas fa-layer-group"></i>
        </div>
        <div id="layersList"></div>
        <div class="layer-stats" id="layerStats">جاري تحميل الطبقات...</div>
      </div>

      <div class="control-buttons">
        <button class="control-btn hide-all-btn" id="hideAllLayers"><i class="fas fa-eye-slash"></i><span>إخفاء الكل</span></button>
        <button class="control-btn show-all-btn" id="showAllLayers"><i class="fas fa-eye"></i><span>إظهار الكل</span></button>
      </div>
    </div>
  `;

  $('#layersSectionContent').html(panelHtml);

  // تحميل أولي + ربط مراقبة
  renderLayersList();
  bindCollectionWatchers();

  $('#showAllLayers').off('click').on('click', showAllLayers);
  $('#hideAllLayers').off('click').on('click', hideAllLayers);
}

function hideLayersPanel() {
  $('#layersSection').slideUp(200);
}

/* =========================
   ديناميكية كاملة: بناء القائمة + مراقبة المجموعة
   ========================= */

// توليد بيانات العرض من خصائص الطبقة أو افتراضيات جميلة
function getDisplayMeta(layer) {
  const name = layer.get('name');
  const title = layer.get('title') || beautifyName(name);
  const description = layer.get('description') || 'طبقة بيانات خرائطية';
  const icon = layer.get('icon') || 'fas fa-layer-group';
  return { name, title, description, icon };
}

// تحويل name لاسم قابل للقراءة
function beautifyName(name) {
  if (!name) return 'طبقة غير مُسمّاة';
  return name
    .replace(/_/g, ' ')
    .replace(/\b\w/g, m => m.toUpperCase());
}

// ربط مستمع تغيّر خصائص الطبقة (لتحديث الـ UI لما تتغيّر الرؤية من الخارج)
function bindLayerPropertyWatcher(layer) {
  const name = layer.get('name');
  if (!name) return;

  // منع الازدواج
  if (layer._boundForLayersUI) return;
  layer._boundForLayersUI = true;

  layer.on('propertychange', (e) => {
    if (e.key === 'visible') {
      // لو الطبقة مخفية من الواجهة، ما في عناصر لتُحدّثها
      const $cb = $(`#${name}`);
      const $item = $(`.modern-layer-item[data-layer="${name}"]`);
      if ($cb.length === 0 || $item.length === 0) return;

      const checked = layer.getVisible();
      $cb.prop('checked', checked);
      $item.toggleClass('active', checked);
      updateLayerStatsFromDOM();
    }
  });
}

// مراقبة مجموعة الطبقات: إضافة/حذف
let _collectionBound = false;
function bindCollectionWatchers() {
  if (_collectionBound) return;
  _collectionBound = true;

  // اربط لكل الموجودين حاليًا
  layers.forEach(bindLayerPropertyWatcher);

  // عند الإضافة: اربط المراقبة وأعد الرسم
  layers.on('add', (evt) => {
    const layer = evt.element;
    bindLayerPropertyWatcher(layer);
    requestAnimationFrame(renderLayersList);
  });

  // عند الحذف: أعد الرسم
  layers.on('remove', () => {
    requestAnimationFrame(renderLayersList);
  });
}

// بناء القائمة من كل الطبقات المُسمّاة وغير المخفية
function renderLayersList() {
  let layersHtml = '';
  let visibleCount = 0;
  let totalCount = 0;

  [...layers.getArray()].slice().reverse().forEach(layer => {
    const name = layer.get('name');
    if (!name) return;              // تجاهل الطبقات غير المُسمّاة
    if (isHiddenLayer(layer)) return; // تجاهل الطبقات الداخلية/المخفية

    const { title, description, icon } = getDisplayMeta(layer);
    const isVisible = layer.getVisible();

    totalCount += 1;
    if (isVisible) visibleCount += 1;

    layersHtml += `
    <div class="modern-layer-item ${isVisible ? 'active' : ''}" data-layer="${name}">
      <div class="layer-icon"><i class="${icon}"></i></div>
      <div class="layer-info">
        <h6 class="layer-name">${title}</h6>
        <p class="layer-description">${description}</p>
      </div>
      <div class="layers-checkbox-container">
        <input type="checkbox" id="${name}" ${isVisible ? 'checked' : ''}>
      </div>
    </div>
  `;
  });


  $('#layersList').html(layersHtml);
  updateLayerStats(visibleCount, totalCount);

  // نقر على العنصر كاملًا
  $('.modern-layer-item').off('click').on('click', function (e) {
    e.preventDefault();
    const layerName = $(this).data('layer');
    const checkbox = $(`#${layerName}`);
    const nextState = !checkbox.prop('checked');
    checkbox.prop('checked', nextState);
    toggleLayerVisibility(layerName, nextState);
    $(this).toggleClass('active', nextState);
    updateLayerStatsFromDOM();
  });

  // نقر على الـ checkbox نفسه
  $('.layers-checkbox-container input[type="checkbox"]').off('click').on('click', function (e) {
    e.stopPropagation();
    const layerName = this.id;
    toggleLayerVisibility(layerName, this.checked);
    $(this).closest('.modern-layer-item').toggleClass('active', this.checked);
    updateLayerStatsFromDOM();
  });
}

/* =========================
   أوامر على الطبقات
   ========================= */
function toggleLayerVisibility(layerName, visible) {
  const layer = getlayerByName(layerName);
  if (!layer) return;
  layer.setVisible(visible);

  // ── حفظ الحالة فوراً بعد كل تغيير ──
  saveLayerVisibility();

  // Refresh snapping if active
  if (window.refreshSnapping) {
    window.refreshSnapping();
  }

  // مثال سلوك خاص بطبقة معينة (اختياري):
  if (!visible && layerName === 'New_Parcel' && window.closeParcelPopup) {
    window.closeParcelPopup();
  }
}

function updateLayerStats(visible, total) {
  const percentage = total > 0 ? Math.round((visible / total) * 100) : 0;
  $('#layerStats').html(`
    <strong>${visible}</strong> من <strong>${total}</strong> طبقات مرئية
    (<strong>${percentage}%</strong>)
  `);
}

function updateLayerStatsFromDOM() {
  const total = $('.modern-layer-item').length;
  const visible = $('.modern-layer-item.active').length;
  updateLayerStats(visible, total);
}

function showAllLayers() {
  $('.modern-layer-item').each(function () {
    const name = $(this).data('layer');
    toggleLayerVisibility(name, true);
    $(`#${name}`).prop('checked', true);
    $(this).addClass('active');
  });
  updateLayerStatsFromDOM();
  saveLayerVisibility();
}

function hideAllLayers() {
  layers.forEach(layer => {
    const name = layer.get('name');
    if (!name) return;

    // Only hide layers that are meant to be in the layers panel (not basemaps, not internal)
    if (!isHiddenLayer(layer)) {
      toggleLayerVisibility(name, false);
      $(`#${name}`).prop('checked', false);
      $(`.modern-layer-item[data-layer="${name}"]`).removeClass('active');
    }
  });
  updateLayerStatsFromDOM();
  saveLayerVisibility();
}
window.hideAllLayers = hideAllLayers;
